<header
  class="fixed inset-x-0 top-0 z-[47] flex h-[var(--header-offset-mobile)] w-full items-center justify-between bg-whiteshade/75 pt-[var(--sat)] pr-[calc(var(--sar)+16px)] pl-[calc(var(--sal)+16px)] backdrop-blur-sm dark:bg-blacker/75 [body:has(main.stats)_&]:bg-whiteshade/95 dark:[body:has(main.stats)_&]:bg-blacker/95"
>
  <div class="flex items-center gap-2">
    <app-profile-menu [user]="user"></app-profile-menu>
    @if (user) {
    <a
      class="flex h-[32px] w-[28px] items-center justify-center"
      routerLink="/stats"
      [attr.aria-label]="'STATS' | translate"
      [title]="'STATS' | translate"
    >
      <span
        class="block h-[26px] w-[24px] bg-black mask-[url(/assets/images/icons/stats.svg)] mask-size-[24px_26px] dark:bg-white"
      ></span>
    </a>
    }
  </div>
  <a class="logo absolute left-1/2 -translate-x-1/2" routerLink="/">
    <span
      class="block w-[120px] h-[25px] bg-black dark:bg-white mask-[url(/assets/images/icons/gemster-logo-typo.svg)] mask-size-[120px_25px]"
    ></span>
  </a>
  @if (user) {
  <div class="flex items-center gap-2">
    <app-discussions-button></app-discussions-button>
    <app-notifications
      class="notifications cursor-pointer"
      [user]="user"
    ></app-notifications>
  </div>
  }
</header>
